import type { IconType } from '../../../../theme/themes/ThemeTypes';

export const TariffRecommender: IconType = ({ colour, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={33} height={42} fill="none" {...props}>
    <path
      stroke={colour}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10.555 9.697V7.955M13.156 9.697H9.624A2.336 2.336 0 0 0 7.29 12.03c0 .956.58 1.802 1.463 2.165l3.592 1.44a2.33 2.33 0 0 1 1.295 3.036 2.328 2.328 0 0 1-2.165 1.463H7.93M10.555 21.865v-1.742"
    />
    <path
      stroke={colour}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M31.42 39.258c0 .956-.774 1.742-1.742 1.742H3.6a1.742 1.742 0 0 1-1.741-1.742V2.742C1.859 1.786 2.633 1 3.6 1h16.68c.46 0 .907.181 1.234.508l9.41 9.41c.327.327.508.775.508 1.234v27.094l-.012.012Z"
    />
    <path
      stroke={colour}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.982 1.157v8.54c0 .955.774 1.742 1.742 1.742h8.539M7.229 28.82h18.978M17.547 23.607h8.66M20.994 18.393h5.213M7.229 34.033h18.978"
    />
  </svg>
);
